// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_aq-2";
export var aiChatCartContainerExit = "_aq-4";
export var aiChatContainerLarge = "_aq-0";
export var aiChatContainerSmall = "_aq-1";
export var aiChatIcon = "_aq-6";
export var slideInFromRight = "_aq-3";
export var slideOutToRight = "_aq-5";